export default "__VITE_ASSET__B_COYA7J__"